import React, { useState, useEffect } from "react";
import { Helmet } from "react-helmet";
import { hexToRgb } from "../api/core";
import { DARK, THBTD, BACKGROUND } from "../../global";

const Color = (props) => {
  const color_list = JSON.parse(localStorage.getItem("color") || "[]");
  const theme_state = props.theme;
  const initState = {
    primaryBackgroundColor:
      color_list != null ? color_list.primaryBackgroundColor : "",
    secondaryBackgroundColor:
      color_list != null ? color_list.secondaryBackgroundColor : "",
    primaryTextColor: color_list != null ? color_list.primaryTextColor : "",
    secondaryTextColor: color_list != null ? color_list.secondaryTextColor : "",
    primaryHighlightColor:
      color_list != null ? color_list.primaryHighlightColor : "",
    secondaryHighlightColor:
      color_list != null ? color_list.secondaryHighlightColor : "",
    menuBackgroundColor:
      color_list != null ? color_list.menuBackgroundColor : "",
    /*  elementBackgroundColor:
      color_list != null ? THBTD!=="IMG"?color_list.elementBackgroundColor:`rgba(` +
      hexToRgb(color_list.elementBackgroundColor) +
      `,0.75)!important;` : "", */
    elementBackgroundColor:
      color_list != null ? color_list.elementBackgroundColor : "",
    elementForegroundColor:
      color_list != null ? color_list.elementForegroundColor : "",
    buttonBackgroundColor:
      color_list != null
        ? color_list.buttonBackgroundColor
          ? color_list.buttonBackgroundColor
          : color_list.primaryHighlightColor
        : "",
    buttonForegroundColor:
      color_list != null
        ? color_list.buttonForegroundColor
          ? color_list.buttonForegroundColor
          : color_list.elementForegroundColor
        : "",
    menuForegroundColor:
      color_list != null
        ? color_list.menuForegroundColor
          ? color_list.menuForegroundColor
          : color_list.primaryTextColor
        : "",
  };

  const [colorSchema, setColor] = useState(initState);
  useEffect(() => {
    let colorState = {
      primaryBackgroundColor: "",
      secondaryBackgroundColor: "",
      primaryTextColor: "",
      secondaryTextColor: "",
      primaryHighlightColor: "",
      secondaryHighlightColor: "",
      menuBackgroundColor: "",
      elementBackgroundColor: "",
      elementForegroundColor: "",
      buttonBackgroundColor: "",
      buttonForegroundColor: "",
      menuForegroundColor: "",
    };

    if (DARK) {
      colorState = {
        primaryBackgroundColor: "#f0f0f0",
        secondaryBackgroundColor: "#ffffff",
        primaryTextColor: "#000000",
        secondaryTextColor: "#333333",
        primaryHighlightColor: props.data.primaryHighlightColor,
        secondaryHighlightColor: props.data.secondaryHighlightColor,
        menuBackgroundColor: "#ffffff",
        elementBackgroundColor: THBTD === "IMG" ? "#1b1b1b36" : "#fefefe",
        elementForegroundColor: THBTD === "IMG" ? "#ffffff" : "#000000",
        buttonBackgroundColor: props.data.buttonBackgroundColor,
        buttonForegroundColor: props.data.buttonForegroundColor,
        menuForegroundColor: "#000000",
      };
    } else {
      colorState = {
        primaryBackgroundColor: "#242424",
        secondaryBackgroundColor: "#1b1b1b",
        primaryTextColor: "#ffffff",
        secondaryTextColor: "#989898",
        primaryHighlightColor: props.data.primaryHighlightColor,
        secondaryHighlightColor: props.data.secondaryHighlightColor,
        menuBackgroundColor: "#1b1b1b",
        elementBackgroundColor: "#1b1b1b36",
        elementForegroundColor: "#ffffff",
        buttonBackgroundColor: props.data.buttonBackgroundColor,
        buttonForegroundColor: props.data.buttonForegroundColor,
        menuForegroundColor: "#ffffff",
      };
    }

    const getColorData = async (colorState) => {
      let data = await props.data;

      if (theme_state === DARK) {
        setColor(data);
      } else {
        setColor(colorState);
      }
    };
    getColorData(colorState);
  }, [props.data, theme_state]);

  return (
    <Helmet>
      <style type="text/css">
        {`
        body
        {
          background-image:url(` +
          BACKGROUND +
          `);
          background-repeat: repeat;
          background-position: center;
        }
    :root
    {
     --iq-primary:` +
          colorSchema.primaryHighlightColor +
          ` !important ;
     --iq-primary-hover: ` +
          colorSchema.secondaryHighlightColor +
          ` !important;
     --iq-white: ` +
          colorSchema.primaryTextColor +
          ` !important;
     --iq-body-text: ` +
          colorSchema.primaryTextColor +
          ` !important;
     --iq-body-bg: ` +
          colorSchema.primaryBackgroundColor +
          ` !important;
     --iq-secondy-body: ` +
          colorSchema.secondaryBackgroundColor +
          ` !important;
     --iq-text-color: ` +
          colorSchema.secondaryTextColor +
          ` !important;
     --iq-menu-bg: ` +
          colorSchema.menuBackgroundColor +
          ` !important;
          --iq-menu-forecolor: ` +
          colorSchema.menuForegroundColor +
          ` !important;
          --iq-button-forecolor: ` +
          colorSchema.buttonForegroundColor +
          ` !important;
          --iq-button-background: ` +
          colorSchema.buttonBackgroundColor +
          ` !important;
     --iq-element-body:rgba(` +
          hexToRgb(colorSchema.elementBackgroundColor) +
          `,0.45)!important;
     --iq-element-color: ` +
          colorSchema.elementForegroundColor +
          ` !important;
     --iq-rgb-body:rgb(` +
          hexToRgb(colorSchema.primaryBackgroundColor) +
          `)!important;
     --iq-rgb-second-body:rgb(` +
          hexToRgb(colorSchema.secondaryBackgroundColor) +
          `)!important;
     --iq-rgb-primary:rgb(` +
          hexToRgb(colorSchema.primaryHighlightColor) +
          `)!important;
     --iq-rgb-text:rgb(` +
          hexToRgb(colorSchema.primaryTextColor) +
          `)!important;
     --iq-rgba-text:rgba(` +
          hexToRgb(colorSchema.primaryTextColor) +
          `,0.05)!important;
     --iq-rgba-primary:rgba(` +
          hexToRgb(colorSchema.primaryHighlightColor) +
          `,0.3)!important;
     --iq-rgba-body:rgba(` +
          hexToRgb(colorSchema.primaryBackgroundColor) +
          `,0.3)!important;
     --iq-rgba-second-body:rgba(` +
          hexToRgb(colorSchema.secondaryBackgroundColor) +
          `,0.5)!important;
     --iq-rgba-element-body:rgba(` +
          hexToRgb(colorSchema.elementBackgroundColor) +
          `,0.5)!important;

    }
 `}
      </style>
    </Helmet>
  );
};

export default Color;
